import { render } from "./SvgIcon.vue?vue&type=template&id=4b7f3098"
import script from "./SvgIcon.vue?vue&type=script&lang=js"
export * from "./SvgIcon.vue?vue&type=script&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=4b7f3098&lang=css"
script.render = render

export default script